<template>
  <el-form ref="ref_form" :model="interferenceForm" :rules="rules" label-width="120px">
    <div v-for="(item, index) in interferenceForm.dataList" :key="index" class="game-cutline">
      <el-form-item label="">
        <el-checkbox v-model="item.state" :true-label="1" :false-label="0">学习内容{{ index + 1 }}是否选用</el-checkbox>
      </el-form-item>

      <el-form-item
        v-if="courseData.curriculumType === 'READING' || courseData.curriculumType === 'SENTENCE' || courseData.curriculumType === 'REVIEWREADING' || courseData.curriculumType === 'REVIEWSENTENCE' || courseData.curriculumType === 'TESTREADING' || courseData.curriculumType === 'TESTSENTENCE'"
        :label="'学习内容' + (index + 1)"
        :prop="'dataList.' + index + '.studyId'"
        :rules="rules.studyId"
      >
        <el-select v-model="item.studyId" placeholder="请选择" filterable style="width: 500px;">
          <el-option v-for="sentence in item.sentenceList" :key="sentence.id" :label="sentence.desc" :value="sentence.id" />
        </el-select>
      </el-form-item>
      <el-form-item v-else :label="'学习内容' + (index + 1)" :prop="'dataList.' + index + '.wordName'" :rules="rules.wordName">
        <el-input v-model="item.wordName" disabled style="width: 350px;" />
      </el-form-item>
      <el-form-item label="">
        <div class="setGame-first-img">
          <el-image style="width: 100px; height: 100px" :src="item.url" fit="fit" />
          <h3>原内容卡片图</h3>
        </div>
      </el-form-item>
      <el-form-item v-if="item.state === 1" label="判定结果" :prop="'dataList.' + index + '.decideFlag'" :rules="rules.decideFlag">
        <el-radio-group v-model="item.decideFlag">
          <el-radio :label="1">正确</el-radio>
          <el-radio :label="2">错误</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item
        v-if="item.state === 1 && item.decideFlag === 2"
        label="资料库干扰项"
        :prop="'dataList.' + index + '.interfereIds'"
        :rules="rules.interfereIds"
      >
        <el-select v-model="item.interfereIds" placeholder="请选择" clearable filterable style="width: 500px;">
          <el-option v-for="item2 in interferenceListOptions(item)" :key="item2.id" :label="item2.name" :value="item2.id" :disabled="isOptionsDisable(item, item2)" />
        </el-select>
      </el-form-item>

      <el-form-item v-if="item.state === 1 && item.decideFlag === 2" label="自定义干扰项">
        <el-button type="success" size="small" :disabled="item.interfereCardList.length >= 1" @click="addCustomerInterfereCard(index)">添加干扰项</el-button>
        <br>
        <div v-for="(item3, index3) in item.interfereCardList" :key="index3" class="interfereCard">
          <div class="cont">
            <el-form-item label="内容" label-width="60px" style="margin-bottom: 10px;">
              <el-input v-model="item3.wordName" maxlength="20" placeholder="请输入单词/字母名称" />
            </el-form-item>
            <el-form-item label="卡片图" label-width="60px">
              <themeUploadAvatar code="customImg" :file-list.sync="item3.imgFile" />
            </el-form-item>
          </div>
          <el-button type="warning" size="small" @click="deleteCustomerInterfereCard(index, index3)">删除</el-button>
        </div>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import themeUploadAvatar from '../../components/themeUploadAvatar'
// import { getDictoryInfoByCode } from '@/api/api_common.js'
import { saveConfData } from '@api/courseManagement/api_quiz'
export default {
  components: {
    themeUploadAvatar
  },
  props: {
    timestamp: {
      type: Number,
      default: 0
    },
    moduleType: {
      type: String,
      default: ''
    },
    currentQuizType: {
      type: String,
      default: ''
    },
    gameList: {
      type: Array,
      default: function () {
        return []
      }
    },
    interferenceList: {
      type: Array,
      default: function () {
        return []
      }
    },
    interferenceList2: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      interferenceForm: {
        dataList: [

        ]
      },
      rules: {
        studyId: [{ required: true, message: '请选择', trigger: 'change' }],
        wordName: [{ required: true, message: '请选择', trigger: 'change' }],
        decideFlag: [{ required: true, message: '请选择', trigger: 'change' }],
        interfereIds: [{ required: false, message: '请选择干扰项', trigger: 'change' }]
      }

    }
  },
  computed: {
    ...mapState('courseStep', ['courseData', 'stepOptions', 'stepActive'])
  },
  watch: {
    gameList: function (val) {
      this.interferenceForm.dataList = []
      this.gameList.forEach((item, index) => {
        const studyId = item.studyId || item.sentenceList[0].id
        this.interferenceForm.dataList.push({ state: item.state, studyId: studyId, decideFlag: item.decideFlag ? item.decideFlag : 1, wordName: item.wordName, url: item.cardChartRootPath, meansType: item.meansType, sentenceList: item.sentenceList, interfereIds: item.interfereIds ? Number(item.interfereIds) : '', interfereCardList: [] })

        const interfereCardList = item.interfereCustomMeans ? item.interfereCustomMeans : []
        for (const item2 of interfereCardList) {
          this.interferenceForm.dataList[index].interfereCardList.push({ wordName: item2.wordName, imgFile: [{ name: item2.cardChartName, paramsFileName: item2.cardChartName, paramsUrl: item2.cardChartPath, url: item2.cardChartRootPath }] })
        }
      })
    }
  },
  created () {

  },
  methods: {
    // 根据游戏类型 和 meansType 判断 干扰项取值
    interferenceListOptions (item) {
      // 自然拼读 的句型 放到第二个干扰项选项
      if (item.meansType === '4') {
        return this.interferenceList2
      } else {
        return this.interferenceList
      }
    },
    getOptions () {

      // getDictoryInfoByCode ('').then(res => {  })
    },
    addCustomerInterfereCard (index) {
      this.interferenceForm.dataList[index].interfereCardList.push({ wordName: '', imgFile: [] })
    },
    deleteCustomerInterfereCard (index, index3) {
      this.$confirm('是否确认删除干扰项?', '提示', {
        type: 'warning',
        closeOnClickModal: false
      }).then(() => {
        this.interferenceForm.dataList[index].interfereCardList.splice(index3, 1)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    isOptionsDisable (item, item2) {
      let flag = false
      if (this.currentQuizType === '2002' || this.currentQuizType === '4003') {
        if (item.parentId === item2.id) {
          flag = true
        } else {
          flag = false
        }
      } else {
        if (item.studyId === item2.id) {
          flag = true
        } else {
          flag = false
        }
      }
      return flag
    },
    // 验证干扰项 选择必填项
    isValidateOptions () {
      let flag = false
      const arr = _.cloneDeep(this.interferenceForm.dataList)
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].state === 0 || arr[i].decideFlag === 1) {
          continue
        }
        for (var j = 0; j < arr[i].interfereCardList.length; j++) {
          if (arr[i].interfereCardList[j].wordName === '' || arr[i].interfereCardList[j].imgFile.length === 0) {
            this.$message.error(`学习内容${i + 1}自定义干扰项信息未填写完整`)
            flag = true
            return flag
          }
        }

        if (arr[i].interfereIds && arr[i].interfereCardList.length === 1) {
          this.$message.error(`学习内容${i + 1}资料库干扰项与自定义干扰项必须只能选其一`)
          flag = true
          return flag
        } else if (!arr[i].interfereIds && arr[i].interfereCardList.length === 0) {
          this.$message.error(`学习内容${i + 1}资料库干扰项与自定义干扰项必须选其一`)
          flag = true
          return flag
        }
      }
      return flag
    },
    saveGameOptions () {
      this.$refs.ref_form.validate(valid => {
        if (!valid) { return false }
        const arr = _.cloneDeep(this.interferenceForm.dataList)
        let checkTotal = 0
        for (var i = 0; i < arr.length; i++) {
          checkTotal = checkTotal + arr[i].state
        }
        if (checkTotal === 0) {
          this.$message.error(`请至少选中一条学习内容`)
          return false
        }

        if (this.isValidateOptions()) {
          return false
        }

        for (const item of arr) {
          if (item.state === 1 && item.decideFlag === 2) {
            item.interfereIds = item.interfereIds ? [item.interfereIds] : []

            item.interfereCustomMeans = item.interfereCardList
            for (const item2 of item.interfereCustomMeans) {
              item2.cardChartName = item2.imgFile[0].paramsFileName
              item2.cardChartPath = item2.imgFile[0].paramsUrl
            }
          } else {
            item.interfereIds = []
            item.interfereCustomMeans = null
          }
        }

        const params = {
          curriculumId: this.courseData.teachingCurriculumId,
          curriculumType: this.courseData.curriculumType,
          quizType: this.currentQuizType,

          items: arr
        }

        saveConfData(params).then(res => {
          this.$message.success('操作成功')
          this.$emit('finishSave')
        })
      })
    }
  }
}
</script>

<style lang='scss'>
.setGame-first-img{
  display: inline-block;
  margin-right: 20px;
  text-align: center;

}
.setGame-sencond-img{
  display: inline-block;
  /*text-align: center;*/
  .themeUploadAvatar .btn-tip{
    display: inline-block;
    margin-left: 10px;
  }
}

</style>
